import React from "react";

export default function bridge2BeginTeam() {
  const bridgeBeginteamMembers = [
    {
      name: "Ms. Amaya Sajith",
      img: "/img/famphy-bridge2begin-img01.jpg",      
      desc: `
        <p>Worked as a Counsellor in a Special School.</p>
        <ul>
          <li>She is an attentive listener with good communication skills with clients and families.</li>
          <li>Skilled in conducting psychological observations, informal assessments and progress tracking.</li>
          <li>Amaya is compassionate and dedicated with keen interest in:</li>
          </ul>
          <ul>
            <li>Observing and understanding behavioural patterns among children and adolescents.</li>
            <li>Implementing basic behavior management plans for children under supervision.</li>
            <li>Providing supportive and basic counseling to patients and families.</li>
          </ul>        
      `,
    },
    {
      name: "Riya Ann Subhash",
      img: "/img/famphy-bridge2begin-img02.jpg",      
      desc: `
        <p>Dedicated Speech Language Pathologist with 3 years of experience providing high-quality care to patients with speech, language and swallowing disorders.</p>
        <p>Completed Bachelor’s in Audiology and Speech-Language Pathology from a renowned institution. Experienced in diagnosing and providing therapy for various age groups.</p>
        <p><strong>Riya Ann is Specialized in</strong></p>
        <ul>
          <li>Speech & Language Assessment and Therapy</li>
          <li>Voice and Fluency Management</li>
          <li>Swallowing and Feeding Therapy</li>
          <li>Augmentative and Alternative Communication (AAC)</li>
          <li>Cognitive-Communication Rehabilitation</li>
        </ul>
      `,
    },
    {
      name: "Kasi Sreelekha",
      img: "/img/famphy-bridge2begin-img03.jpg",      
      desc: `
        <p>Dedicated Occupational Therapist with 2+ years of experience in pediatric rehabilitation and developmental therapy.</p>
        <p>Certified Occupational Therapist.</p>
        <p>Skilled in assessing patient needs and improving therapy effectiveness.</p>
        <p><strong>Sreelekha is Specialized in</strong></h3>
        <ul>
          <li>Pediatric Occupational Therapy</li>
          <li>Sensory Integration Techniques</li>
          <li>Fine & Gross Motor Skill Development</li>
          <li>ADL (Activities of Daily Living) Training</li>
          <li>Attention and Concentration Enhancement</li>
          <li>Play-Based Therapeutic Approaches</li>
          <li>Parent Guidance & Home Program Planning</li>
        </ul>
      `,
    },
  ];

  return (
    <div className="container">
      <div className="ourteam-section">
        <h2>Our Bridge2Begin Experts</h2>       

        <div className="team-flex">
          {bridgeBeginteamMembers.map((doc, i) => (
            <div className="team-card" key={i}>
              <div className="teamimg">
                <img
                  className="img-fluid"
                  src={`${process.env.PUBLIC_URL}${doc.img}`}
                  alt={doc.name}
                />
              </div>
              <div className="teamcontent">
                <h5>{doc.name}</h5>
                {/* Render HTML inside desc */}
                <div
                  className="team-desc"
                  dangerouslySetInnerHTML={{ __html: doc.desc }}
                />                              
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
